const employerCustomerEmails = ["quinnipiac.edu", "qu.edu"];

export function isEmployerCustomerEmail(email) {
  const domain = email.split("@")[1];
  return employerCustomerEmails.includes(domain)
    ? //domain.split(".")[0]
      "quinnipiac"
    : "";
}
